// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"eead37dc","700":"c1223139"}[chunkId] + ".chunk.js";
};